export default "__VITE_ASSET__Dn6Rr$ag__"